import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./StageData.css";
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Sidebar from "../../../components/Sidebar/Sidebar";
import UserProfileDropdown from "../../../components/UserProfile/UserProfile";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { getAllApplications } from "../../../redux/ApplicationReducer/action";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";

const StageAnalytics = () => {
    const navigate = useNavigate();
    const { stageName } = useParams();

    console.log({ stageName });

    const { applications, pagination } = useSelector((store) => {
        return {
            applications: store.ApplicationReducer.applications.data,
            pagination: store.ApplicationReducer.applications.pagination
        }
    }, []);
    const dispatch = useDispatch();

    const storedFilters = JSON.parse(sessionStorage.getItem('applicationStageFilters')) || {};

    const [showFilterModal, setShowFilterModal] = useState(false);
    const [applicationStageFilters, setApplicationStageFilters] = useState({
        ro_id: storedFilters?.ro_id || "",
        application_id: storedFilters?.application_id || "",
        application_stage_name: stageName || "",
        branch_name: storedFilters?.branch_name || "",
        branch_code: storedFilters?.branch_code || "",
        seeds_id: storedFilters?.seeds_id || "",
        name: storedFilters?.name || "",
        ro_name: storedFilters?.ro_name || "",
        bm_name: storedFilters?.bm_name || "",
        start_date: storedFilters?.start_date || "",
        end_date: storedFilters?.end_date || "",
        customer_id: storedFilters?.customer_id || "",
        global_search: storedFilters?.global_search || ""
    });

    const [dateRange, setDateRange] = useState([
        applicationStageFilters?.start_date ? new Date(applicationStageFilters.start_date) : null,
        applicationStageFilters?.end_date ? new Date(applicationStageFilters.end_date) : null,
    ]);

    const [startDate, endDate] = dateRange;

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('currentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('limit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('totalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    const getActiveFilterCount = () => {
        let count = 0;
        const keys = [
            "ro_id",
            "application_id",
            "branch_name",
            "branch_code",
            "seeds_id",
            "name",
            "ro_name",
            "bm_name",
            "start_date",
            "end_date",
            "customer_id",
            "global_search"
        ];
        keys.forEach(key => {
            if (applicationStageFilters[key] && applicationStageFilters[key] !== "") {
                count++;
            }
        });
        return count;
    };

    const handleClearFilters = () => {
        const cleared = {
            ro_id: "",
            application_id: "",
            application_stage_name: stageName || "",
            branch_name: "",
            branch_code: "",
            seeds_id: "",
            name: "",
            ro_name: "",
            bm_name: "",
            start_date: "",
            end_date: "",
            customer_id: "",
            global_search: ""
        };
        setDateRange([null, null]);
        setApplicationStageFilters(cleared);
        setCurrentPage(1);
        sessionStorage.setItem("applicationStageFilters", JSON.stringify(cleared));
        sessionStorage.setItem("currentPage", "1");
    };

    useEffect(() => {
        let cleanFilters = { ...applicationStageFilters };
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (uuidRegex.test(cleanFilters.seeds_id?.trim() || "") || cleanFilters.seeds_id?.includes("...")) {
            cleanFilters.seeds_id = "";
        }

        dispatch(getAllApplications(currentPage, limit, cleanFilters))

        sessionStorage.setItem('currentPage', currentPage);
        sessionStorage.setItem('limit', limit);
        sessionStorage.setItem('applicationStageFilters', JSON.stringify(applicationStageFilters));
    }, [dispatch, limit, currentPage, applicationStageFilters]);

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('currentPage', pageToSet.toString());
        const scrollContainer = document.querySelector('.pageContentWrapper') || document.querySelector('.leadPageContentWrapper');
        const tableElement = document.querySelector('.tableCard');
        const stickyHeader = document.querySelector('.stickyHeaderContainer');
        if (scrollContainer && tableElement) {
            const offsetTop = tableElement.offsetTop;
            const stickyHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
            scrollContainer.scrollTo({
                top: offsetTop - stickyHeight - 12,
                behavior: 'smooth'
            });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleDateRangeChange = (update) => {
        setDateRange(update);

        const [start, end] = update;

        const formatDate = (date) => {
            if (!date) return "";
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const updatedFilters = {
            ...applicationStageFilters,
            start_date: formatDate(start),
            end_date: formatDate(end),
        };

        setApplicationStageFilters(updatedFilters);
        handlePageChange(1);
        sessionStorage.setItem("applicationStageFilters", JSON.stringify(updatedFilters));
    };

    const handleFilterChange = (e) => {
        let { name, value } = e.target;

        if (typeof value === 'string') {
            value = value.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
        }

        let updatedFilters = {
            ...applicationStageFilters,
            [name]: value
        };

        if (name === "seeds_id") {
            const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            if (uuidRegex.test(value.trim())) {
                updatedFilters.application_id = value.trim();
            } else if (value.includes("...")) {
                const parts = value.split("...");
                if (parts.length === 2) {
                    const firstPart = parts[0].trim();
                    const lastPart = parts[1].trim();
                    const matchedApp = applications?.find(app => 
                        app.application_id?.startsWith(firstPart) && 
                        app.application_id?.endsWith(lastPart)
                    );
                    if (matchedApp) {
                        updatedFilters.application_id = matchedApp.application_id;
                    } else {
                        updatedFilters.application_id = "";
                    }
                } else {
                    updatedFilters.application_id = "";
                }
            } else {
                updatedFilters.application_id = "";
            }
        }

        setApplicationStageFilters(updatedFilters);
        handlePageChange(1);
        sessionStorage.setItem("applicationStageFilters", JSON.stringify(updatedFilters));
    }

    return (
        <div className="applicationsDashboardContainer">
            <div className="applicationsDashboard">
                <Sidebar />

                <div className="dashboardMainContent">
                    <div className="contentHeader">
                        <div className="userLogo">
                            <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                        </div>
                        <div className="headerRightPanel">
                            <UserProfileDropdown />
                        </div>
                    </div>

                    <div className="pageContentWrapper">
                        <div className="pageHeaderSection">
                        <Breadcrumb items={[
                            { label: 'Home' },
                            { label: 'Application Stage Summary', onClick: () => navigate('/analytics') },
                            { label: `${stageName} Applications` }
                        ]} />
                        <div className="pageActions">
                            <h2>{stageName} Applications</h2>
                            <div className="filterButtons">
                                {getActiveFilterCount() > 0 && (
                                    <button
                                        className="clearFiltersBtn"
                                        onClick={handleClearFilters}
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                        Clear Filters
                                    </button>
                                )}
                                <button
                                    className="allFiltersBtn"
                                    onClick={() => setShowFilterModal(true)}
                                >
                                    <FontAwesomeIcon icon={faFilter} />
                                    All Filters
                                    {getActiveFilterCount() > 0 && (
                                        <span className="activeFilterCount">
                                            {getActiveFilterCount()}
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="tableCard">
                        <div className="applicationsTableContainer">
                            <table className="applications-table">
                                <thead>
                                    <tr>
                                        <th className={applicationStageFilters?.seeds_id ? 'filter-applied' : ''}>Application Number</th>
                                        <th className={applicationStageFilters?.ro_name ? 'filter-applied' : ''}>RO Name</th>
                                        <th className={applicationStageFilters?.ro_id ? 'filter-applied' : ''}>RO ID</th>
                                        <th className={applicationStageFilters?.application_id ? 'filter-applied' : ''}>Application ID</th>
                                        <th className={(applicationStageFilters?.start_date || applicationStageFilters?.end_date) ? 'filter-applied' : ''}>Application Date</th>
                                        <th>Status</th>
                                        <th className={applicationStageFilters?.name ? 'filter-applied' : ''}>Customer Name</th>
                                        <th className={applicationStageFilters?.customer_id ? 'filter-applied' : ''}>Customer ID</th>
                                        <th className={applicationStageFilters?.branch_code ? 'filter-applied' : ''}>Branch ID</th>
                                        <th className={applicationStageFilters?.branch_name ? 'filter-applied' : ''}>Branch</th>
                                        <th className={applicationStageFilters?.bm_name ? 'filter-applied' : ''}>BM Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {applications?.map((application, index) => (
                                        <tr key={index}>
                                            <td
                                                className="blueText"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    const selectedText = window.getSelection().toString();
                                                    if (!selectedText) {
                                                        navigate(`/applications/${application.application_id}`);
                                                    }
                                                }}
                                            >
                                                {application.seeds_id}
                                            </td>
                                            <td>{`${application?.ro?.first_name}${application?.ro?.middle_name ? ` ${application?.ro?.middle_name}` : ''}${application?.ro?.last_name ? ` ${application?.ro?.last_name}` : ''}`}</td>
                                            <td>{application?.ro?.emp_id}</td>
                                            <td>{application?.application_id}</td>
                                            <td>{application?.createdAt?.split('T')?.[0]}</td>
                                            <td>
                                                <span className={`applicationStatus`}>
                                                    {application.application_stage_name}
                                                </span>
                                            </td>
                                            <td>{`${application.first_name}${application?.middle_name ? ` ${application?.middle_name}` : ''}${application?.last_name ? ` ${application?.last_name}` : ''}`}</td>
                                            <td>{application?.external_customer_id}</td>
                                            <td>{application?.branch_code}</td>
                                            <td>{application?.branch_name}</td>
                                            <td>{`${application?.bm?.first_name}${application?.bm?.middle_name ? ` ${application?.bm?.middle_name}` : ''}${application?.bm?.last_name ? ` ${application?.bm?.last_name}` : ''}`}</td>
                                            {/* <td>
                                                <button
                                                    className="actionButton"
                                                    onClick={() => navigate(`/applications/${application.application_id}`)}
                                                >
                                                    View Application
                                                </button>
                                            </td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="paginationControls">
                            <CustomPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
            {/* Advanced Filters Modal */}
            {showFilterModal && (
                <div
                    className="filterModalOverlay filterDrawerOverlay open"
                    onClick={() => setShowFilterModal(false)}
                >
                    <div
                        className="filterModalCard filterDrawerCard"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Modal Header */}
                        <div className="filterModalHeader">
                            <h2>Advanced Filters</h2>
                            <button
                                className="filterModalCloseBtn"
                                onClick={() => setShowFilterModal(false)}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div className="filterModalBody">
                            <div className="filterGrid">
                                <div className="filterField">
                                    <label htmlFor="filter-seeds-id">Application Number</label>
                                    <input
                                        id="filter-seeds-id"
                                        type="text"
                                        name="seeds_id"
                                        value={/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(applicationStageFilters?.seeds_id || '') ? '' : applicationStageFilters?.seeds_id || ''}
                                        placeholder="Search By Application Number"
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className="filterField">
                                    <label htmlFor="filter-app-id">Application ID</label>
                                    <input
                                        id="filter-app-id"
                                        type="text"
                                        name="application_id"
                                        value={applicationStageFilters?.application_id || ''}
                                        placeholder="Exact match"
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className="filterField">
                                    <label htmlFor="filter-ro-name">RO Name</label>
                                    <input
                                        id="filter-ro-name"
                                        type="text"
                                        name="ro_name"
                                        value={applicationStageFilters?.ro_name || ''}
                                        placeholder="Search By RO Name"
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className="filterField">
                                    <label htmlFor="filter-ro-id">RO ID</label>
                                    <input
                                        id="filter-ro-id"
                                        type="text"
                                        name="ro_id"
                                        value={applicationStageFilters?.ro_id || ''}
                                        placeholder="Search By RO ID"
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className="filterField">
                                    <label>Application Date Range</label>
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) =>
                                                    handleDateRangeChange([date, endDate])
                                                }
                                                selectsStart
                                                startDate={startDate}
                                                endDate={endDate}
                                                maxDate={endDate || new Date()}
                                                isClearable
                                                placeholderText="Start Date"
                                                className="date-picker-filter"
                                            />
                                        </div>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) =>
                                                    handleDateRangeChange([startDate, date])
                                                }
                                                selectsEnd
                                                startDate={startDate}
                                                endDate={endDate}
                                                minDate={startDate}
                                                maxDate={new Date()}
                                                isClearable
                                                placeholderText="End Date"
                                                className="date-picker-filter"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="filterField">
                                    <label htmlFor="filter-customer-name">Customer Name</label>
                                    <input
                                        id="filter-customer-name"
                                        type="text"
                                        name="name"
                                        value={applicationStageFilters?.name || ''}
                                        placeholder="Search By Customer Name"
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className="filterField">
                                    <label htmlFor="filter-customer-id">Customer ID</label>
                                    <input
                                        id="filter-customer-id"
                                        type="text"
                                        name="customer_id"
                                        value={applicationStageFilters?.customer_id || ''}
                                        placeholder="Search By Customer ID"
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className="filterField">
                                    <label htmlFor="filter-branch-code">Branch ID (Code)</label>
                                    <input
                                        id="filter-branch-code"
                                        type="text"
                                        name="branch_code"
                                        value={applicationStageFilters?.branch_code || ''}
                                        placeholder="Search By Branch ID"
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className="filterField">
                                    <label htmlFor="filter-branch-name">Branch</label>
                                    <input
                                        id="filter-branch-name"
                                        type="text"
                                        name="branch_name"
                                        value={applicationStageFilters?.branch_name || ''}
                                        placeholder="Search By Branch Name"
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className="filterField">
                                    <label htmlFor="filter-bm-name">BM Name</label>
                                    <input
                                        id="filter-bm-name"
                                        type="text"
                                        name="bm_name"
                                        value={applicationStageFilters?.bm_name || ''}
                                        placeholder="Search By BM Name"
                                        onChange={handleFilterChange}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="filterModalFooter">
                            <button
                                className="clearAllBtn"
                                onClick={handleClearFilters}
                            >
                                Clear All
                            </button>
                            <button
                                className="applyFiltersBtn"
                                onClick={() => setShowFilterModal(false)}
                            >
                                Apply Filters
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StageAnalytics;